import { Link } from 'react-router-dom';
import { useLocale, useT, withLocale } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

export default function IndustriesHub() {
  const locale = useLocale();
  const t = useT();
  const state = useApiData(() => contentApi.industries(locale), [locale]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head reveal is-visible">
          <span className="eyebrow">{t('nav.industries')}</span>
          <h1>{t('nav.view_all_10')}</h1>
        </div>
        <AsyncSection
          state={state}
          render={(industries) => (
            <div className="card-grid">
              {industries.map((i) => (
                <Link className="card reveal is-visible" to={withLocale(`/industries/${i.slug}`, locale)} key={i.slug}>
                  <h3>{i.name}</h3>
                  <p className="body-sm">{i.challenge}</p>
                  <span className="card-link">→</span>
                </Link>
              ))}
            </div>
          )}
        />
      </div>
    </section>
  );
}
